var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0008 16.7498C19.8018 16.7508 19.6107 16.6715 19.4708 16.5298L12.0008 9.05983L4.53082 16.5298C4.23531 16.8052 3.77481 16.7971 3.4892 16.5114C3.20359 16.2258 3.19546 15.7653 3.47082 15.4698L11.4708 7.46983C11.7636 7.17737 12.238 7.17737 12.5308 7.46983L20.5308 15.4698C20.8233 15.7626 20.8233 16.237 20.5308 16.5298C20.3909 16.6715 20.1999 16.7508 20.0008 16.7498Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop);
export default __webpack_public_path__ + "static/media/Top.f6d2138639cfacf557b4246d2a056830.svg";
export { ForwardRef as ReactComponent };